import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../../../util/ext";
import { includes } from "ramda";
import { submissionTypes } from "./uploadUtils";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import UploadColumn from "./UploadColumn";

import { MediaContext } from "../../common/media-context";

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },
}));

const SubmissionDetails = () => {
  const classes = useStyles();
  const context = useContext(MediaContext);

  const isRequired = field => {
    const { type } = context.media;
    return (
      notBlank(context.requiredFields[type]) &&
      includes(field, context.requiredFields[type])
    );
  };

  const formBuilder = handlers => {
    return (
      <Grid className={classes.column} container spacing={4} direction="column">
        <Grid item>
          <Typography variant="h6">
            {submissionTypes[context.media.type].displayName} Info
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="content-title"
            fullWidth
            label="Title"
            required={isRequired("title")}
            value={context.media.title}
            onChange={handlers.onTextChange(["title"])}
            error={context.validator.hasError(context.errors, "title")}
            helperText={context.validator.firstError(context.errors, "title")}
            onBlur={() => handlers.onBlur("title", context.media.title)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="content-subtitle"
            fullWidth
            label="Subtitle (optional)"
            value={context.media.subtitle}
            onChange={handlers.onTextChange(["subtitle"])}
          />
        </Grid>

        {/* <Grid item xs={12} style={{ marginTop: 30 }}>
          <Description
            required={isRequired("description")}
            error={context.validator.hasError(context.errors, "description")}
            helperText={context.validator.firstError(
              context.errors,
              "description",
            )}
          />
        </Grid> */}
      </Grid>
    );
  };

  return <UploadColumn className={classes.root} formBuilder={formBuilder} />;
};

export default SubmissionDetails;
